export const isValidColor = async (value: string) => {
  return !value || CSS.supports('color', value) ? '' : 'Not a valid color'
}
